import { Mask } from '@react-input/mask';
export const useTime = () => {
    const mask = new Mask({
        showMask: true,
        mask: 'hi:mn XY',
        replacement: { h: /[01]/, i: /\d/, m: /[0-5]/, n: /\d/, X: /[AP]/, Y: /M/ },
    });
    const validationPatter = mask.generatePattern('full');
    const isValidRegexp = (value) => {
        return RegExp(validationPatter).test(value);
    };
    const isValidValue = (value) => {
        return !value.startsWith('00') && parseInt(value) < 13;
    };
    const isValid = (value) => {
        return isValidRegexp(value) && isValidValue(value);
    };
    return {
        format: mask.format,
        isValidRegexp,
        isValidValue,
        isValid,
    };
};
